import {DataTable} from "../DataTable/DataTable";
import {SiteAssignmentSiteAssocEntity} from "@ots-frontend/ots-data";
import {DefaultText} from "../../text/DefaultText/DefaultText";
import {useTranslation} from "react-i18next";
import {EntityDataTableProps} from "../EntityDataTable/EntityDataTable";
import {usePagination} from "../DataTable/usePagination";
import {useDataTableSorter} from "../DataTable/useDataTableSorter";

const EMPTY_ARRAY: SiteAssignmentSiteAssocEntity[] = []

export type SiteAssignmentSiteAssocDataTableProps = EntityDataTableProps<SiteAssignmentSiteAssocEntity>

export const SiteAssignmentSiteAssocDataTable = (props: SiteAssignmentSiteAssocDataTableProps) => {
  const {
    records: assignments = EMPTY_ARRAY,
    recordsPerPageOptions,
    ...rest
  } = props

  const {t} = useTranslation(["common"]);

  const {
    sortedRecords,
    sortStatus,
    onSortStatusChange,
  } = useDataTableSorter({
    records: assignments,
    sortStatus: {columnAccessor: 'normalPreferenceRank', direction: 'asc'},
  })

  const pagination = usePagination({
    data: sortedRecords,
    recordsPerPageOptions: recordsPerPageOptions,
  });

  return (
    <DataTable
      {...rest}
      {...(pagination ?? {})}
      sortStatus={sortStatus}
      onSortStatusChange={onSortStatusChange}
      columns={[
        {
          title: t("common.entity.siteassignment.table.column.site", "Site"),
          accessor: "site.name",
          width: 100,
          render: ({site}) => (
            <DefaultText value={site?.name}/>
          ),
          sortable: true,
        },
        {
          title: t("common.entity.siteassignment.table.column.normalrank", "Normal Rank"),
          accessor: "normalPreferenceRank",
          width: 100,
          sortable: true,
        },
        {
          title: t("common.entity.siteassignment.table.column.servicerank", "Service Rank"),
          accessor: "servicePreferenceRank",
          width: 100,
          sortable: true,
        }
      ]}
    />
  );
};
